<template>
  <div class="table-responsive">
    <table class="table">
      <thead>
        <tr>
          <th>Voucher Date</th>
          <th>Party Name</th>
          <th>Txn Ref No</th>
          <th>Receipt Amount</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, i) in tableItems" :key="i">
          <td class="fw-bold">{{ item.receipt_date }}</td>
          <td>{{ item.party }}</td>
          <td>{{ item.voucher_no }}</td>
          <td>{{ commaFormat(item.total_paid_amount) }}</td>
          <td>
            <button v-if="!isHideEditAndReturnButton" class="btn btn-primary btn-sm cursor-pointer"
                    @click="$emit('edit', item.id)"
                    :disabled="item.status === 'returned'">
              <i class="fas fa-eye"></i>
            </button>
            
            <button v-if="item.status !== 'returned' && !isHideEditAndReturnButton" class="btn btn-danger btn-sm p-0 cursor-pointer ml-2"
                    @click="$emit('return', item.id)">
              <i class="far fa-window-close close-icon"></i>
            </button>
            
            <button v-if="!isHidePrintButton" class="btn btn-secondary btn-sm cursor-pointer ml-2"
                    @click="$emit('print', item.id)">
              <i class="fas fa-print"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
    <p v-if="!tableItems || !tableItems.length" class="text-center mt-5">No data</p>
  </div>
</template>

<script setup>
import figureFormatter from '@/services/utils/figureFormatter';
const { commaFormat } = figureFormatter();

defineProps({
  tableItems: {
    type: Array,
    required: true,
    default: () => []
  },
  isHideEditAndReturnButton: {
    type: Boolean,
    default: true
  },
  isHidePrintButton: {
    type: Boolean,
    default: false
  }
});

defineEmits(['edit', 'return', 'print']);
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}
.ml-2 {
  margin-left: 10px;
}
.close-icon {
  font-size: 1.3em;
  margin: 5px 15px;
}
</style>
